<template>
  <div
    class="relative mx-auto my-8 grid w-full grid-cols-[4fr_minmax(0,_1fr)] gap-2 overflow-hidden bg-orange py-4 px-2 text-white lg:container"
  >
    <span class="row-start-1 text-lg font-bold md:text-4xl">
      You have changed your query
    </span>
    <span class="row-start-2 font-bold md:text-2xl">
      Press "Search 9,000+ Agencies" when your new query is ready.
    </span>
    <div
      class="col-start-2 row-span-2 row-start-1 grid max-h-28 w-full place-items-center overflow-visible"
    >
      <IconSearch class="h-8 w-8 md:-top-20 md:h-32 md:w-32" />
    </div>
  </div>
</template>

<script>
import IconSearch from 'Components/Icons/IconSearch.vue';

export default {
  name: 'SearchModified',
  components: { IconSearch },
};
</script>
